import Vue from 'vue'
import Vuex from 'vuex'
import { UserTypes } from '../contants'
import { ObjectId } from 'bson'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    user: {
      schoolName: '',
      userName: '',
      emailAddress: ''
    },
    userType: '',
    userId: '',
    feedback: {
      quant: [],
      qual: ''
    },
    followUpQuestionAsked: false,
    scores: [
      { name: 'advik', score: 0 },
      { name: 'jake', score: 0 },
      { name: 'mel', score: 0 },
      { name: 'kaya', score: 0 }
    ],
    students: [
      {
        id: 1,
        name: 'advik',
        age: '19',
        studying: 'Physiotherapy',
        catchphrase:
          'Sounds good! Let me revise for one more hour and then I’ll come join you!',
        profile:
          'Advik’s an all-round nice guy and likes to balance his studies with opportunities to build friendships. ' +
          'His mild manner sometimes means that he doesn’t speak up about things that bother him. ' +
          'He’s the unofficial counsellor who everyone goes to with their worries and can count on for care and support. ' +
          'He manages money well and does more than his share of the chores, without complaint.',
        result:
          'You strike a good balance between your studies and opportunities to socialise and have fun. ' +
          'You’re considerate of others. In fact, you’re so nice that you sometimes find it difficult to speak up about something that bothers you. ' +
          'Remember that it’s important to get any problems out in the open, or they can escalate. ',
        image: require('@/assets/images/students/advik-1.png'),
        smallimage: require('@/assets/images/students/advik-small.png'),
        frame: require('@/assets/images/phone/advik.png'),
        video:
          'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik1.mp4'
      },
      {
        id: 2,
        name: 'mel',
        age: '20',
        studying: 'Civil Engineering',
        catchphrase:
          'Sorry, I’ll have to give a night out a miss - I’ve got a big exam coming up.',
        profile:
          'Mel’s very sweet but the other flatmates don’t see much of her. ' +
          'She’s very focused on her studies, which means she’s less likely to head out and meet new people. ' +
          'She is super-organised and seen as the first port of call when something practical needs to get done. ' +
          'She’s sensible with money, tightly tracking her expenses, and likes to keep the place clean and tidy.',
        result:
          'You’re dedicated to your studies and prefer to focus on them rather than socialising. ' +
          'Remember that friendship and support can help to motivate you and help you face any challenges. ' +
          'Try to create a comfortable balance between work and play.',
        image: require('@/assets/images/students/mel-1.png'),
        smallimage: require('@/assets/images/students/mel-small.png'),
        frame: require('@/assets/images/phone/mel.png'),
        video:
          'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel1.mp4'
      },
      {
        id: 3,
        name: 'jake',
        age: '19',
        studying: 'Drama',
        catchphrase: 'Come on, even C’s get degrees. I’m going out!',
        profile:
          'Jake is the ultimate social animal. Whether he’s drinking in the local bars or at home, he takes the party wherever he goes. ' +
          'What he lacks in tidiness, organisation and money management, he makes up for in heart. ' +
          'He’s the first to apologise if he has upset someone. ' +
          'He’s pretty easy-going and gets on well with everyone – but can’t seem to build a relationship with his textbooks!',
        result:
          'You love to party and don’t let things like studying get in the way of your ability to have a good time. ' +
          'But you also care about others and hate the thought of offending anyone. ' +
          'Remember that, while there’s definitely time for socialising, students also need a good chunk of quiet study time. ' +
          'Try to create a comfortable balance between work and play.',
        image: require('@/assets/images/students/jake-1.png'),
        smallimage: require('@/assets/images/students/jake-small.png'),
        frame: require('@/assets/images/phone/jake.png'),
        video:
          'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake1.mp4'
      },
      {
        id: 4,
        name: 'kaya',
        age: '18',
        studying: 'Law',
        catchphrase:
          'I want it all – high-flying career, big car, luxury flat. And I’m willing to work hard to make sure I get it.',
        profile:
          'Kaya isn’t a huge fan of studying but she’s focused on her degree and determined to stop at nothing to reach her goals. ' +
          'This sometimes means she loses track of her spending or doesn’t do her share of chores. ' +
          'She loves going out and hanging with her friends, but she’s often absorbed in her own world, daydreaming about what the future holds and what sort of a lawyer she will be.',
        result:
          'You’re very focused on your goals and you do everything you can to achieve them. ' +
          'Remember that having a happy, comfortable living environment can help you feel more relaxed and able to concentrate. ' +
          'It’s important to consider others as well as yourself.',
        image: require('@/assets/images/students/kaya-1.png'),
        smallimage: require('@/assets/images/students/kaya-small.png'),
        frame: require('@/assets/images/phone/kaya.png'),
        video:
          'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya1.mp4'
      }
    ],
    rooms: [
      {
        id: 1,
        name: 'communual-area',
        instruction: false
      },
      {
        id: 2,
        name: 'bedroom',
        instruction: false
      },
      {
        id: 3,
        name: 'kitchen',
        instruction: false
      }
    ],
    questions: [
      {
        id: 1, // Unique ID
        room: 1, // Communual Area
        relativeID: 1, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'Your flatmates invite you out for dinner, but you don’t have enough money. What do you do?',
        answers: [
          {
            id: 1,
            student: 'mel',
            weight: 1,
            text:
              'Make an excuse saying you have too much work to do tonight, but that you’ll try and come next time.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel4.mp4'
          },
          {
            id: 2,
            student: 'kaya',
            weight: 1,
            text:
              'Decide that you’ll use your credit card just this once and go anyway – you really don’t want to miss out.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya4.mp4'
          },
          {
            id: 3,
            student: 'jake',
            weight: 1,
            text:
              'Ask your flatmate if they would mind subbing you some money so you can come with them – you can pay it back as soon as your student loan comes through.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake2.mp4'
          },
          {
            id: 4,
            student: 'advik',
            weight: 1,
            text:
              'Suggest having a flat meal instead – it would be cheaper for everyone but you still get to have fun hanging out for a bit.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik3.mp4'
          }
        ],
        tip:
          'Most students live on a budget. One of the best things you can do is to create your own budget sheet showing when you’ll receive money and how much you spend.' +
          '\n\n' +
          'You can set up direct debits, so that important payments like rent and bills come out automatically; then you’ll know how much you have left for other things. Work out how much you’ve got per week and don’t overspend –  remember, it’s really easy to overspend when you don’t have a solid grip on how much you actually have available.' +
          '\n\n' +
          'There are lots of discounts offered to students – it’s worth researching what’s available in your local area, shopping around for the best deals.'
      },
      {
        id: 2, // Unique ID
        room: 1, // Communual Area
        relativeID: 2, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'Your flatmate is stressed out about their coursework. They keep shutting themselves away in their room. What do you do?',
        answers: [
          {
            id: 1,
            student: 'advik',
            weight: 1,
            text:
              'Bring them a hot cup of tea and see if they feel like chatting about the things that are bothering them. It might help them to talk.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik4.mp4'
          },
          {
            id: 2,
            student: 'mel',
            weight: 1,
            text:
              'Offer to become a study buddy – sometimes working with someone can help ease the anxiety of the work.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel2.mp4'
          },
          {
            id: 3,
            student: 'kaya',
            weight: 1,
            text:
              'Ignore them. What they choose to do is their business. You need to concentrate on your own exams.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya5.mp4'
          },
          {
            id: 4,
            student: 'jake',
            weight: 1,
            text:
              'Invite your flatmate for a drink – maybe getting out for a bit will help relieve the tension.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake6.mp4'
          }
        ],
        tip:
          'Everyone gets stressed, anxious or worried at times. These moments can be particularly challenging if you’re living away from home for the first time.' +
          '\n\n' +
          'The great thing about flatmates is that there’s support close at hand. Talk about your feelings. Chances are that others are going through the same thing, and you can show each other support.' +
          '\n\n' +
          'Most universities also have people you can go to see for advice and support, so it’s always worth checking this option out if you find you are struggling.'
      },
      {
        id: 3, // Unique ID
        room: 2, // Bedroom
        relativeID: 1, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'You’re trying to study for an exam in the morning, but your flatmate has friends over and they’re playing music and messing around in the kitchen, being really loud. What do you do?',
        answers: [
          {
            id: 1,
            student: 'kaya',
            weight: 1,
            text:
              'Go into the kitchen and ask everyone to leave. This is your space and they can make noise in their own flat.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya2.mp4'
          },
          {
            id: 2,
            student: 'mel',
            weight: 1,
            text:
              'Grab your flatmate and politely ask him to get his friends to keep the noise down. Hopefully you can get them to understand the importance of this exam and the need for some quiet study time.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel8.mp4'
          },
          {
            id: 3,
            student: 'jake',
            weight: 1,
            text:
              'Go into the kitchen and join them for a bit – you’ll just have to make sure to grab a coffee in the morning!',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake3.mp4'
          },
          {
            id: 4,
            student: 'advik',
            weight: 1,
            text:
              'Put in some headphones. They don’t completely stop the noise, but you find it a bit easier to concentrate.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik8.mp4'
          }
        ],
        tip:
          'Communication is the golden rule.' +
          '\n\n' +
          'It’s always best to talk about any problems that arise, even when you feel awkward or uncomfortable about bringing them up.' +
          '\n\n' +
          'Study time is crucial in any student flat, and others should respect when someone has pending assignments or exams. You’ll all go through it!' +
          '\n\n' +
          'Politely let your flatmates know when you’ve got important course dates coming up, so they can avoid organising loud gatherings and give you the time you need to concentrate on doing your best. It also helps reduce potential confrontations which, let’s face it, nobody likes.'
      },
      {
        id: 4, // Unique ID
        room: 3, // Kitchen
        relativeID: 1, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'The kitchen’s a mess and there’s a note on the fridge saying, ‘Stop stealing my milk!!!!’. What do you do?',
        answers: [
          {
            id: 1,
            student: 'kaya',
            weight: 1,
            text: 'Leave the note where it is and head out for some food rather than staying in and using the kitchen.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya8.mp4'
          },
          {
            id: 2,
            student: 'jake',
            weight: 1,
            text:
              'Let it wash over you and crack on with making your own dinner – half the mess is probably yours anyway.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake7.mp4'
          },
          {
            id: 3,
            student: 'mel',
            weight: 1,
            text:
              'Get everyone together and suggest creating a kitchen-cleaning and milk-buying roster.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel3.mp4'
          },
          {
            id: 4,
            student: 'advik',
            weight: 1,
            text:
              'Clean the kitchen yourself and pop out to grab enough milk for everyone to share.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik5.mp4'
          }
        ],
        tip:
          'Some of us find it easier to be tidier than others and we all have different ideas about what ‘tidy’ really looks like.' +
          '\n\n' +
          'But when you live with others you need to make more of an effort to keep the communal areas clean and enjoyable places to be.' +
          '\n\n' +
          'Speak with your flatmates and agree how you want to organise your shared space, and what foodstuffs you are happy to share and how you will go about buying these. It can help to set some ‘house rules’ at the beginning so everyone knows what the expectation is and encourage everyone to follow them – even guests.'
      },
      {
        id: 5, // Unique ID
        room: 3, // Kitchen
        relativeID: 2, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'When you first moved in, all the flatmates ate dinner together and had a laugh, but now people have gone off in their own little groups. You’re feeling a bit lonely. What do you do?',
        answers: [
          {
            id: 1,
            student: 'jake',
            weight: 1,
            text:
              'Organise a flat party to build a bit more of a connection with your flatmates. Why not invite some other uni friends as well – the more the merrier!',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake4.mp4'
          },
          {
            id: 2,
            student: 'advik',
            weight: 1,
            text:
              'Cook a delicious dinner for everyone – surely the best way to coax everyone out of their rooms.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik6.mp4'
          },
          {
            id: 3,
            student: 'kaya',
            weight: 1,
            text:
              'You feel a bit left out so go and catch up with other friends instead.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya6.mp4'
          },
          {
            id: 4,
            student: 'mel',
            weight: 1,
            text:
              'It doesn’t really bother you. You need to focus on getting some coursework done, so you decide to throw yourself into that.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel5.mp4'
          }
        ],
        tip:
          'It can be common for students to experience loneliness and feelings of isolation, especially if family and friends from school are far away. But remember that lots of students are in the same boat – it’s not just you.' +
          '\n\n' +
          'Talk to others regularly and try to make sure everyone feels welcome and included. Just because someone didn’t want to join in the socialising last time doesn’t mean it will always be the case.' +
          '\n\n' +
          'Don’t be afraid to ask for help or support when you need it. And keep an eye out for anyone else who seems to be going through a rough time.'
      },
      {
        id: 6, // Unique ID
        room: 3, // Kitchen
        relativeID: 3, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'You arrive home after a night out with mates. You feel really tired but you’re starving! You have some food in the fridge that you could use to cook a quick stir-fry.',
        answers: [
          {
            id: 1,
            student: 'advik',
            weight: 1,
            text:
              'You’re too tired to cook so you nip out for a cheeky kebab.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik7.mp4'
          },
          {
            id: 2,
            student: 'kaya',
            weight: 1,
            text:
              'You know you’re too tired to cook so you gently wake a flatmate and ask if they’d help you.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya9.mp4'
          },
          {
            id: 3,
            student: 'jake',
            weight: 1,
            text:
              'Grab the food and start cooking! You can wolf down the meal and then go to bed.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake8.mp4'
          },
          {
            id: 4,
            student: 'mel',
            weight: 1,
            text:
              'Ignore your stomach and go to bed. You know you’re too tired to cook – you don’t want to fall asleep with the hob on and accidentally set fire to the flat.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel6.mp4'
          }
        ],
        tip:
          'Cooking is the most common cause of household fires and most are easily preventable with the right precautions.' +
          '\n\n' +
          'Never start cooking if you’re tired or under the influence of alcohol or drugs. The risks of you having an accident or falling asleep while you are cooking are much greater.' +
          '\n\n' +
          'Switch on your cooker extractor and never leave cooking unattended. Keep fire doors closed and make sure hallways and exits are free from obstructions.'
      },
      {
        id: 7, // Unique ID
        room: 1, // Communal area
        relativeID: 3, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'A letter arrives asking you to pay your TV Licence fee (around £155 for the year). You think it should be split evenly between you and your flatmates. What do you do?',
        answers: [

          {
            id: 1,
            student: 'advik',
            weight: 1,
            text:
              'Pay all of the fee yourself (so you know it’s paid on time) and then ask each of your flatmates to pay you back their share.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik2.mp4'
          },
          {
            id: 2,
            student: 'mel',
            weight: 1,
            text:
              'Check the rules around TV licences for students and come up with a plan with your flatmates.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel9.mp4'
          },
          {
            id: 3,
            student: 'kaya',
            weight: 1,
            text:
              'Leave some money on the table, next to the letter. That’s your share sorted. Others should organise theirs. ',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya3.mp4'
          },
          {
            id: 4,
            student: 'jake',
            weight: 1,
            text:
              'Ignore it. You only watch TV on your laptop and you’re not sure that students need a TV Licence anyway.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake5.mp4'
          }
        ],
        tip:
          'In most cases, students need to be covered by a TV Licence.' +
          '\n\n' +
          'We know it’s probably the last thing on your mind, but it’s really important that you check the TV Licensing website to find out the rules for your particular living situation. The fines for getting this wrong can be hefty.' +
          '\n\n' +
          'Sometimes you can have a TV Licence for the whole house, but you may find that each person needs an individual licence.'
      },
      {
        id: 8, // Unique ID
        room: 2, // Bedroom
        relativeID: 2, // ID Relative to the room
        answered: false,
        answer: 0,
        question:
          'One of your flatmates recently split up with her partner and you’ve noticed she’s been drinking a lot lately. To make matters worse, she gets quite aggressive when drunk. Last night you noticed her crying and drinking a bottle of wine, alone in her room. What do you do?',
        answers: [
          {
            id: 1,
            student: 'mel',
            weight: 1,
            text: 'Knock on her door and ask her if she’d like to talk.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Mel7.mp4'
          },
          {
            id: 2,
            student: 'jake',
            weight: 1,
            text:
              'Get rid of all the alcohol in the flat and tell her that you are worried that she seems to be drinking a lot at the moment.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Jake9.mp4'
          },
          {
            id: 3,
            student: 'advik',
            weight: 1,
            text:
              'Make an extra effort to be friendly and invite her to spend time with you – you could watch a movie or cook dinner together.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Advik9.mp4'
          },
          {
            id: 4,
            student: 'kaya',
            weight: 1,
            text:
              'Leave her be. She’ll sort herself out in time, and anyway, it’s not your job to play ‘mum’.',
            feedback:
              'https://waf-unite-students.s3.eu-west-2.amazonaws.com/static/videos/2/Kaya7.mp4'
          }
        ],
        tip:
          'Antisocial behaviour can be caused by alcohol or drugs, but it could also be due to someone struggling to cope or social anxiety.' +
          '\n\n' +
          'The most important thing is to keep an eye on each other and be approachable. People might not always want to talk about their problems, but they usually find it comforting to know that someone who cares about them is there.' +
          '\n\n' +
          'All universities have support services, so you can always encourage friends and flatmates to ask them for help as well, and if you’re not sure how to help, they can advise you about this too.'
      }
    ]
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    saveAnswer (state, payload) {
      const q = this.getters.getCurrentQuestion(payload[0])
      q.answered = true
      q.answer = payload[1]
      console.log('Answer ID: ' + q.answer)
    },
    saveUserType (state, payload) {
      state.userType = payload
    },
    saveUser (state, payload) {
      state.user.userName = payload.userName
      state.user.emailAddress = payload.emailAddress
      state.user.schoolName = payload.schoolName
    },
    updateScore (state, payload) {
      const student = this.getters.getScoreByName(payload[0])
      student.score += payload[1]
    },
    updateInstruction (state, payload) {
      const r = this.getters.getRoomByName(payload)
      r.instruction = true
    },
    updateFeedback (state, payload) {
      state.feedback.quant.push(payload)
    },
    updateFollowUpQuestionAsked (state, payload) {
      state.followUpQuestionAsked = payload
    },
    updateUserId (state, userId) {
      state.userId = userId.toString()
    }
  },
  methods: {},
  getters: {
    getQuestionsAnswered: state => state.questionsAnswered,
    // Score Getters
    getScore: state => state.scores,
    getScoreByName: state => payload =>
      state.scores.find(score => score.name === payload),
    // Student Getters
    getStudents: state => state.students,
    getStudent: state => payload =>
      state.students.find(student => student.id === payload),
    getStudentByName: state => payload =>
      state.students.find(student => student.name === payload),
    // Room Getters
    getRooms: state => state.rooms,
    getRoom: state => payload => state.rooms.find(room => room.id === payload),
    getRoomByName: state => payload =>
      state.rooms.find(room => room.name === payload),
    // Question Getters
    getQuestions: state => state.questions,
    getRoomQuestions: state => payload =>
      state.questions.filter(question => question.room === payload),
    getCurrentQuestion: state => payload =>
      state.questions.find(question => question.id === payload),
    // User Getters
    getUserData: state => state.user || {},
    getUserType: state => state.userType || '',
    isTeacher: state => state.userType === UserTypes.TEACHER,
    isParent: state => state.userType === UserTypes.PARENT,
    isStudent: state => state.userType === UserTypes.STUDENT,
    getUserId: state => {
      return state.userId ? new ObjectId(state.userId) : null
    },
    getFeedback: state => {
      const f = state.feedback || {}
      f.quant = f.quant || []
      return f
    },
    getFollowUpQuestionAsked: state => {
      return !!state.followUpQuestionAsked
    }
  },
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },

    saveAnswer ({ commit }, payload) {
      commit('saveAnswer', payload)
    },

    async saveUserType ({ commit, dispatch }, payload) {
      commit('saveUserType', payload)

      await dispatch('startMongoDbSession', payload)
    },

    async saveUser ({ commit, dispatch, getters }, payload) {
      commit('saveUser', payload)

      console.log('Save User with Id: ' + getters.getUserId)
      await dispatch('storeResponsesInMongoDb', {
        userName: payload.userName || undefined,
        schoolName: payload.schoolName || undefined,
        userEmail: payload.emailAddress || undefined
      })
    },

    async updateScore ({ commit, dispatch, getters }, payload) {
      commit('updateScore', payload)

      const scoreArray = getters.getScore

      const map = Math.max.apply(
        Math,
        scoreArray.map(function (o) {
          return o.score
        })
      )
      if (map === 0) {
        return
      }

      await dispatch('storeResponsesInMongoDb', {
        characterMostLike: scoreArray.find(function (o) {
          return o.score === map
        }).name
      })
    },

    updateInstruction ({ commit }, payload) {
      commit('updateInstruction', payload)
    },

    async updateFeedback ({ commit, dispatch }, payload) {
      const key = payload.key
      const val = payload.val
      if (!!key && (!!val || val === false)) {
        commit('updateFeedback', payload)

        await dispatch('storeResponsesInMongoDb', {
          [`feedbackSurvey.${key}`]: val
        })
      }
    },

    async setFollowUpQuestionAsked ({ commit }) {
      commit('updateFollowUpQuestionAsked', true)
    },

    // This is kept in Vuex because we want to persist the userId
    async startMongoDbSession ({ commit }, userType) {
      const userId = await this.mongoDbService.startAsync(userType)

      // store the id for future updates
      commit('updateUserId', userId)
    },

    // This is kept in Vuex because we want to persist the userId
    async storeResponsesInMongoDb ({ getters, commit }, record) {
      let userId = new ObjectId(getters.getUserId)
      userId = await this.mongoDbService.sendAsync(record, userId)

      // store the id for future updates
      commit('updateUserId', userId)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js